type TAllowedTypes = Element | EventTarget;

export const isGivenHtmlType = <T extends HTMLElement>(
    element: TAllowedTypes,
    type: new () => T,
): element is T => element instanceof type;
